import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";
import Contact from "@/pages/Contact";
import ScrollToTop from "@/components/site/ScrollToTop";
import SmoothScroll from "@/components/site/SmoothScroll";
import "@/App.css";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <SmoothScroll />
        <Navbar />
        <main className="pt-20 bg-parchment">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/:slug" element={<BrandDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#1B0A1E",
              border: "1px solid rgba(225,29,96,0.4)",
              color: "#FBF7F1",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
